import { FC, useMemo } from "react";
import { AppShell } from "@mantine/core";
import { Outlet } from "react-router-dom";
import classNames from "classnames";
import { Footer } from "../Footer";
import { Header } from "../Header";
import {
  useKeyboardVisibility,
  useDismissKeyboard,
  useRouteChecks,
  useTelegramWebApp,
  useResetEditmode,
} from "@shared/utils";

import styles from "./MainLayout.module.scss";

export const MainLayout: FC = () => {
  const {
    inHeaderCheckRouter,
    isHomePage,
    isIntroFormPage,
    isMatchPage,
    isMatchSecondVersionPage,
  } = useRouteChecks();

  useKeyboardVisibility();
  useDismissKeyboard();
  useTelegramWebApp();
  useResetEditmode();

  const footerMemo = useMemo(() => <Footer />, []);

  return (
    <AppShell className={styles.safeArea}>
      {!Object.values(inHeaderCheckRouter).some(Boolean) && <Header />}
      <AppShell.Main
        className={classNames(styles.main, {
          [styles.homePage]: isHomePage,
          [styles.scrollablePage]:
            !isHomePage &&
            !isIntroFormPage &&
            !isMatchPage &&
            !isMatchSecondVersionPage,
        })}
      >
        <div className={styles.outlet}>
          <Outlet />
        </div>
      </AppShell.Main>
      {footerMemo}
    </AppShell>
  );
};
